(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('bidding')
        .factory('BiddingFactory', BiddingFactory);

    function BiddingFactory() {

        function CycleDTO() {
        	  this.cycleId = null;
        	  this.version = null;
        	  this.cycleName = null;
        	  this.dateFrom = null;
        	  this.dateTo = null;
        	  this.crewGroupCode = null;
        }

        function BiddingSearchRequest(){
        	this.cycleId = null;
        	this.crewGroup = null;
        	this.crewBase = null;
        	this.fleetType = null;
        	this.pageSize = null;
        	this.startPosition = null;
        	this.crewTypeCode = null;
        	this.crewId = null;
        	this.requestType = null;

        }

        function BiddingCrewInfoDTO(){
        	this.crewTypeCode = null;
        	this.cycleId = null;
            this.crewId = null;
            this.crewProfId = null;
            this.crewName = null;
            this.crewGroup = null;
            this.alvGroup = null;
        	this.biddingData = null;
        }

        function BiddingRequestInfoDTO(){
        	this.crewRequestId = null;
        	this.version = null;
        	this.crewProfId = null;
        	this.reqType = null;
        	this.biddingDay = null;
        	this.biddingDate = null;
        	this.biddingDetail = null;
        	this.approved = null;
        	this.approvedBy = null;
        	this.userSelectedToApprove = null;
        	this.popOverFlag = null;
        	this.approvedBy = null;
        	this.displayText = null;
        	this.comment = null;
        }

        function BiddingRequestDTO(){
        	this.biddingId = null;
        	this.crewTypeCode = null;
        	this.crewName = null;
        	this.requestDate = null;
        	this.requestType = null;
        	this.durationType = null;
        	this.departureType = null;
        	this.patternName = null;
        	this.patternByNameToggle = false;
        }

        function AssignBiddingRequestDTO(){
          this.approveBiddingRequestType = 'ALL'
        	this.selectedBiddingCrewCollection = [];
        }

        function DeleteBiddingRequestDTO(){
        	this.requestList = [];
        }

        function SelectedBiddingCrewDTO(){
        	this.biddingType = null;
        	this.crewProfileId = null;
        	this.crewId = null;
        	this.crewRequestIds = [];
        }

        function DeleteBiddingCrewDTO(){
        	this.crewRequestId = null;
        	this.version = null;
        	this.deleteRequestDate = null;
        }

        function PatternNameSearchRequest(){
        	this.crewTypeCode = null;
        	this.requestDate = null;
        }

        function DurationTypeDTO(){
        	this.durationTypeCode = null;
        	this.durationTypeDisplay = null;
        }

        function DepartureTypesDTO(){
        	this.departureTypeCode = null;
        	this.departureTypeDescription = null;
        }

        function SaveBiddingRequest(){
        	this.crewProfileId = null
        	this.requestedDate = null;
        	this.requestType = null;
        	this.isNot = false;
        	this.departureTypeCode = null;
        	this.durationTypeCode = null;
        	this.patternName = null;
        	this.dayPriority = null;
        }

        function RequestPriorityDTO(){
        	this.crewGroupDesc = null;
        	this.crewGroupCode = null;
        }

        function MaxCrewBiddingData(){
        	this.crewType = null;
        	this.maxBidding = null;
        }

    	function FormateCycleMasterData(cycleList){
    		var formattedList = [];
	        angular.forEach(cycleList, function (cycle) {
	        	var mstCycle = new CycleDTO();
	        	mstCycle.cycleId = cycle.cycleId;
	        	mstCycle.cycleName = cycle.cycleName;
	        	mstCycle.dateFrom = cycle.dateFrom;
	        	mstCycle.dateTo = cycle.dateTo;
	        	mstCycle.crewGroupCode = cycle.crewGroupCode;
	            formattedList.push(mstCycle);
	        });
	        return formattedList;
    	}

    	function PopulateBiddingDetailsSearchRequest(postData){
    		var request = new BiddingSearchRequest();
    		request.cycleId = postData.cycle.cycleId;
    		request.fleetType = postData.fleetType == null ? null :postData.fleetType.airCraftType;
    		request.crewBase = postData.crewBase == null ? null :postData.crewBase.airPortCode;
    		request.crewGroup = postData.crewGroup == null ? null :postData.crewGroup.groupCode;
    		request.crewTypeCode = postData.crewType == null ? null : postData.crewType.crewTypeCode;
    		request.crewId = postData.crewId == null ? null :postData.crewId;
    		request.pageSize = postData.pageSize;
    		request.startPosition = postData.startPosition;
    		request.requestType = postData.reqType.reqTypeCode;
    		return request;
    	}

    	function FormatBiddingRequestData(biddingRequests){
    		var formattedList = [];
	        angular.forEach(biddingRequests, function (biddingRequest) {
	        	var bdnReq = new BiddingRequestInfoDTO();
	        	bdnReq.crewRequestId = biddingRequest.crewRequestId;
	        	bdnReq.version = biddingRequest.version;
	        	bdnReq.crewProfId = biddingRequest.crewProfId;
	        	bdnReq.reqType = biddingRequest.reqType;
	        	bdnReq.isExactPattern = (biddingRequest.reqType == "OFF" || biddingRequest.reqType == "VUNP" || biddingRequest.patternName != null) ? true : false;
	        	bdnReq.displayText = biddingRequest.reqType == "OFF" || biddingRequest.reqType == "VUNP" ?  biddingRequest.reqType :
	        		(biddingRequest.patternName != null ? biddingRequest.patternName :
	        			( setEmptySringIfNull(biddingRequest.durTypeCode) +" "+ biddingRequest.depTypeCode));

	        	bdnReq.approved = biddingRequest.status == 0 ? false : true;
	        	bdnReq.approvedBy = null;
	        	bdnReq.userSelectedToApprove = false;
	        	bdnReq.popOverFlag = false;
	        	bdnReq.approvedBy = biddingRequest.approvedBy != null ? (" by : "+biddingRequest.approvedBy) : "";

	        	bdnReq.biddingDetail = bdnReq.displayText;

	        	var mo_reqdate = moment(biddingRequest.reqDate, 'DD/MM/YYYY');
	        	var biddingDay = mo_reqdate.format('D');
	        	bdnReq.biddingDay = biddingDay;

	        	bdnReq.biddingDate = biddingRequest.reqDate;
	        	bdnReq.comment = biddingRequest.requestComment;

	            formattedList.push(bdnReq);
	        });
	        return formattedList;
    	}

    	function FormatCrewBiddingSearchData(crewBiddingData){
    		var formattedList = [];
	        angular.forEach(crewBiddingData, function (crewBidding) {
	        	var bdn = new BiddingCrewInfoDTO();
	        	bdn.crewTypeCode = crewBidding.crewTypeCode;
	        	bdn.cycleId = crewBidding.cycleId;
	        	bdn.crewId = crewBidding.crewId;
	        	bdn.crewProfId = crewBidding.crewProfId;
	        	bdn.crewName = crewBidding.crewName;
	        	bdn.crewGroup = crewBidding.crewGroup;
	        	bdn.alvGroup = crewBidding.alvGroup;
	        	bdn.biddingData = FormatBiddingRequestData(crewBidding.biddingData);

	            formattedList.push(bdn);
	        });
	        return formattedList;
    	}

    	function populateNewBiddingCrewInfoDTO(crewInfo){
    		var newCrewInfo = new BiddingCrewInfoDTO();
    		newCrewInfo.crewTypeCode = crewInfo.crewTypeCode;
    		newCrewInfo.cycleId = crewInfo.cycleId;
    		newCrewInfo.crewId = crewInfo.crewId;
    		newCrewInfo.crewProfId = crewInfo.crewProfId;
    		newCrewInfo.crewName = crewInfo.crewName;
    		newCrewInfo.crewGroup = crewInfo.crewGroup;
    		newCrewInfo.biddingData = [];
    		return newCrewInfo;
    	}

    	function populateNewBidRequest(bidRequest){
    		var newBidRequest = new BiddingRequestInfoDTO();
    		newBidRequest.crewRequestId = bidRequest.crewRequestId;
    		newBidRequest.version = bidRequest.version;
    		newBidRequest.crewProfId = bidRequest.crewProfId;
    		newBidRequest.reqType = bidRequest.reqType;
    		newBidRequest.biddingDay = bidRequest.biddingDay;
    		newBidRequest.biddingDate = bidRequest.biddingDate;
    		newBidRequest.biddingDetail = bidRequest.biddingDetail;
    		newBidRequest.approved = bidRequest.approved;
    		newBidRequest.approvedBy = bidRequest.approvedBy;
    		newBidRequest.displayText = bidRequest.displayText
    		return newBidRequest;
    	}


    	function addBidRequestToCrewInfo(selectedBidCrew,selectedBid){

    		var crewBidExist = false;

    		if(selectedBidCrew != null && selectedBidCrew.biddingData!= null ){
    			angular.forEach(selectedBidCrew.biddingData, function (biddingData) {
    				if(biddingData.crewRequestId == selectedBid.crewRequestId){
    					crewBidExist = true;
    				}
    			});
    		}

    		if(!crewBidExist){
    			selectedBidCrew.biddingData.push(selectedBid);
    		}

    		return selectedBidCrew;
    	}

    	function PopulateSelectedCrewBiddingList(selectedCrewBiddingList,selectedBidCrew, selectedBid){

    		var newCrewInfo = populateNewBiddingCrewInfoDTO(selectedBidCrew);
    		var newBidRequest = populateNewBidRequest(selectedBid);
   			newCrewInfo = addBidRequestToCrewInfo(newCrewInfo,newBidRequest);

   			var newCrewBiddingList = [];

   			var isCrewInforExist = false;
   			angular.forEach(selectedCrewBiddingList, function (selectedCrewBiddingInfo) {
   				if(selectedCrewBiddingInfo.crewProfId == newCrewInfo.crewProfId ){
   					isCrewInforExist = true;
   				}
   			});

   			if(!isCrewInforExist){
   				newCrewBiddingList.push(newCrewInfo);
   			}


    		angular.forEach(selectedCrewBiddingList, function (selectedCrewBiddingInfo) {

    			if(selectedCrewBiddingInfo.crewProfId != newCrewInfo.crewProfId){
    				newCrewBiddingList.push(selectedCrewBiddingInfo);
    			}else{
    				var previouesSelectedBids = [];

    				angular.forEach(selectedCrewBiddingInfo.biddingData, function (previouesSelectedBid) {
 	        			if(previouesSelectedBid.crewRequestId != newBidRequest.crewRequestId ){
 	        				previouesSelectedBids.push(previouesSelectedBid);
 	        			}
 	        		});

    				previouesSelectedBids.push(newBidRequest);

    				newCrewInfo.biddingData = previouesSelectedBids;

    				newCrewBiddingList.push(newCrewInfo);
    			}

 	        });

    		return newCrewBiddingList;

    	}

    	function RemoveSelectedCrewBid(selectedCrewBidList , crewBidDel){

    		angular.forEach(selectedCrewBidList, function (selectedCrewBid) {

    			if(selectedCrewBid.crewProfId == crewBidDel.crewProfId){

    				angular.forEach(selectedCrewBid.biddingData, function (bid) {
 	        			if(bid.crewRequestId == crewBidDel.crewRequestId ){
 	        				var index = selectedCrewBid.biddingData.indexOf(bid);
 	        				selectedCrewBid.biddingData.splice(index,1);
 	        			}
 	        		});

    				if(selectedCrewBid.biddingData == null ||
    						selectedCrewBid.biddingData.length == 0){
    					var index = selectedCrewBidList.indexOf(selectedCrewBid);
	        			selectedCrewBidList.splice(index,1);
    				}

    			}

 	        });

    		return selectedCrewBidList;

    	}

    	function PopulateDirrectApproveRequest(postData){
    		var crewInfo = postData.crewInfo;
    		var bidInfo = postData.bidInfo;

    		var selectedBidding = new SelectedBiddingCrewDTO();
    		selectedBidding.crewProfileId = crewInfo.crewProfId
    		selectedBidding.crewId = crewInfo.crewId;
    		selectedBidding.biddingType = bidInfo.reqType;
    		selectedBidding.crewRequestIds.push(bidInfo.crewRequestId);

    		var assignBiddingRequest = new AssignBiddingRequestDTO();
    		assignBiddingRequest.selectedBiddingCrewCollection.push(selectedBidding);

    		return assignBiddingRequest;
    	}

    	function PopulateApprveBidCollectionRequest(postData , approvalType){
    		var assignBiddingRequest = new AssignBiddingRequestDTO();
    		if(!!approvalType){
    		  assignBiddingRequest.approveBiddingRequestType = approvalType;
        }
    		angular.forEach(postData, function (crewBid) {
        		angular.forEach(crewBid.biddingData, function (biddingData) {
        			if(!biddingData.approved) {
        				var selectedBidding = new SelectedBiddingCrewDTO();
                		selectedBidding.crewProfileId = crewBid.crewProfId
                		selectedBidding.crewId = crewBid.crewId;
            			selectedBidding.biddingType = biddingData.reqType;
                		selectedBidding.crewRequestIds.push(biddingData.crewRequestId);

                		assignBiddingRequest.selectedBiddingCrewCollection.push(selectedBidding);
        			}
        		});
 	        });
    		return assignBiddingRequest;

    	}

    	function PopulateDeleteBidCollectionRequest(postData){
    		var deleteBiddingRequest = new DeleteBiddingRequestDTO();
    		angular.forEach(postData, function (crewBid) {
        		angular.forEach(crewBid.biddingData, function (biddingData) {
        			var deleteBidding = new DeleteBiddingCrewDTO();
        			deleteBidding.crewRequestId = biddingData.crewRequestId;
        			deleteBidding.version = biddingData.version;
        			deleteBidding.deleteRequestDate = biddingData.biddingDate;

        			deleteBiddingRequest.requestList.push(deleteBidding);
        		});
 	        });
    		return deleteBiddingRequest;
    	}

    	function ResetDataCollection(dataCollection){
    		angular.forEach(dataCollection, function (crewInfo) {
    			angular.forEach(crewInfo.biddingData, function (bid) {
    				bid.userSelectedToApprove = false;
 	        	});
 	        });

    		return dataCollection;
    	}

    	function ResetSelectedBid(dataCollection,selectedBid){
    		angular.forEach(dataCollection, function (crewInfo) {
    			angular.forEach(crewInfo.biddingData, function (bid) {
    				if(bid.crewRequestId == selectedBid.crewRequestId){
    					bid.userSelectedToApprove = false;
    				}
 	        	});
 	        });

    		return dataCollection;
    	}


    	function GetNewBidRequest(){
    		var request = new BiddingRequestDTO();
    		request.requestType = false;
    		return request;
    	}

    	function GetPatternNamesSearchRequest(params){
    		var request = new PatternNameSearchRequest();
    		request.crewTypeCode = params.crewTypeCode.crewTypeCode;
			request.requestDate = params.requestDate;
    		return request;
    	}

    	function CreateNewBidRequest(params){
    		var request = new SaveBiddingRequest();
    		request.crewProfileId = params.crewName.crewProfileId;
    		request.requestType = !params.requestType ? "OFF" : "PATTERN";
    		request.requestedDate = params.requestDate;

    		request.patternName = params.patternName != null ? params.patternName.patternName : null;
    		request.departureTypeCode = params.departureType != null ? params.departureType.departureTypeCode : null;
    		request.durationTypeCode = params.durationType != null ? params.durationType.durationTypeCode : null;

    		return request;
    	}

    	function FormatDurationTypeResponse(durations) {
    		var result = [];

   			angular.forEach(durations, function (duration) {
   				var dur = new DurationTypeDTO();
   				dur.durationTypeCode = duration.durationTypeCode;
   				dur.durationTypeDisplay = " " + duration.durationTypeDesc;
   				result.push(dur);
   			});

   			return result;
    	}

    	function FormatDepatureTypeResponse(departureTypes){
    		var result = [];

   			angular.forEach(departureTypes, function (departureType) {
   				var dur = new DepartureTypesDTO();
   				dur.departureTypeCode = departureType.departureTypeCode;
   				dur.departureTypeDescription = " " + departureType.departureTypeDescription;
   				result.push(dur);
   			});

   			return result;
    	}

    	function FormatRequestPrioritySearchResponse(requestPriority){
    		var result = [];

   			angular.forEach(requestPriority, function (reqp) {
   				var reqPriority = new RequestPriorityDTO();
   				reqPriority.departureTypeCode = reqp.crewGroupCode;
   				reqPriority.departureTypeDescription = reqp.crewGroupDesc;
   				result.push(reqPriority);
   			});

   			return result;
    	}

    	function FormatMaxCrewBiddingResponse(response){
    		var result = [];
    		angular.forEach(response, function (data) {
   				var maxCrewBiddingData = new MaxCrewBiddingData();
   				maxCrewBiddingData.crewType = data.crewType;
   				maxCrewBiddingData.maxBidding = parseInt(data.maxBidding);
   				result.push(maxCrewBiddingData);
   			});
    		return result;
    	}

    	function PopulateSaveCrewMaxBiddingRequest(request){
    		var result = [];
    		angular.forEach(request, function (data) {
   				var maxCrewBiddingData = new MaxCrewBiddingData();
   				maxCrewBiddingData.crewType = data.crewType;
   				maxCrewBiddingData.maxBidding = data.maxBidding;
   				result.push(maxCrewBiddingData);
   			});
    		return result;
    	}

    	function setEmptySringIfNull(value){
    		if(value === null){
    			return "";
    		}

    		return value;
    	}

        return {
        	formateCycleMasterData : FormateCycleMasterData,
        	populateBiddingDetailsSearchRequest : PopulateBiddingDetailsSearchRequest,
        	formatCrewBiddingSearchData : FormatCrewBiddingSearchData,
        	populateSelectedCrewBiddingList : PopulateSelectedCrewBiddingList,
        	removeSelectedCrewBid : RemoveSelectedCrewBid,
        	populateDirrectApproveRequest : PopulateDirrectApproveRequest,
        	populateApprveBidCollectionRequest : PopulateApprveBidCollectionRequest,
        	populateDeleteBidCollectionRequest : PopulateDeleteBidCollectionRequest,
        	resetDataCollection : ResetDataCollection,
        	resetSelectedBid : ResetSelectedBid,
        	getNewBidRequest : GetNewBidRequest,
        	getPatternNamesSearchRequest : GetPatternNamesSearchRequest,
        	createNewBidRequest : CreateNewBidRequest,
        	formatDurationTypeResponse : FormatDurationTypeResponse,
        	formatDepatureTypeResponse : FormatDepatureTypeResponse,
        	formatRequestPrioritySearchResponse : FormatRequestPrioritySearchResponse,
        	formatMaxCrewBiddingResponse : FormatMaxCrewBiddingResponse,
        	populateSaveCrewMaxBiddingRequest : PopulateSaveCrewMaxBiddingRequest
        }
    }
})();
